import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    FormGroup,
} from "@mui/material";
import { useEffect, useState } from "react";
import { SERIES_LABEL_BY_TYPE } from "../DeviceChart";

const ToggleSeriesDialog = ({ series, trigger, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            {trigger({ onClick: () => setIsOpen(true) })}

            {isOpen && (
                <ToggleSeriesDialogComponent
                    series={series}
                    onChange={(series) => {
                        onChange(series);
                        setIsOpen(false);
                    }}
                    onClose={() => setIsOpen(false)}
                />
            )}
        </>
    );
};

const ToggleSeriesDialogComponent = ({ series: initialValue, onChange: onConfirm, onClose }) => {
    const [series, setSeries] = useState([]);

    useEffect(() => setSeries(initialValue), [initialValue]);

    const isEverythingShown = series?.map(({ visible }) => Boolean(visible)).every(Boolean);

    const showAllSeries = () => setSeries(series.map((item) => ({ ...item, visible: true })));
    const toggleSeriesByType = (type) => {
        setSeries(
            series.map((item) => {
                if (item.type === type) {
                    return { ...item, visible: !item.visible };
                }

                return item;
            })
        );
    };

    return (
        <Dialog fullScreen={false} open={true} onClose={onClose}>
            <DialogTitle>Select Series to Display</DialogTitle>

            <DialogContent>
                <FormGroup>
                    <Box component="div" style={{ marginBottom: "10px" }}>
                        <FormControlLabel
                            label="Show All"
                            style={{ display: "block" }}
                            control={<Checkbox onChange={showAllSeries} checked={isEverythingShown} />}
                        ></FormControlLabel>
                    </Box>
                </FormGroup>

                <FormGroup>
                    {series?.map(({ type, visible }) => (
                        <Box component="div" key={type} style={{ marginBottom: "10px" }}>
                            <FormControlLabel
                                key={`${type}`}
                                style={{ display: "block" }}
                                control={
                                    <Checkbox
                                        onChange={() => toggleSeriesByType(type)}
                                        checked={visible}
                                        value={{ type }}
                                    />
                                }
                                label={SERIES_LABEL_BY_TYPE[type]}
                            />
                        </Box>
                    ))}
                </FormGroup>
            </DialogContent>

            <DialogActions>
                <Button color="primary" onClick={onClose}>
                    Cancel
                </Button>
                <Button color="primary" onClick={() => onConfirm(series)}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ToggleSeriesDialog;
